
import { Button, Popover } from 'element-ui';
import { MapPinIcon, ClockIcon } from 'vue-feather-icons';
import CarriersHoraire from '@/pages/cart/components/CarriersHoraire.vue';

export default {
  props: {
    shop: {
      type: Object,
      required: true,
    },
    selected: {
      type: Boolean,
      default: false,
    },
    small: {
      type: Boolean,
      default: false,
    },
    solo: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      showSchedules: false,
    };
  },

  methods: {
    onClick() {
      if (!this.disabled) {
        this.$emit('click');
      }
    },
    toggleSchedules(event) {
      this.showSchedules = !this.showSchedules;
    },
  },

  computed: {
    disabled() {
      return !this.shop.Active || !this.shop.PickingActive;
    },
  },

  components: {
    MapPinIcon,
    ClockIcon,
    Button,
    Popover,
    CarriersHoraire,
  },
};
